const BASIC_OPTION = {
    color:[],//饼图中各模块的颜色
    series: [{
        type: 'pie',//echarts图的类型   pie代表饼图
        radius: ['75%', '100%'],//饼图中饼状部分的大小所占整个父元素的百分比
        center: ['50%', '50%'],//整个饼图在整个父元素中的位置
        data: [],//模块数据
        hoverAnimation: false,
        labelLine: {
            show: false
        },
        label: {
            show: false,
            position: 'center'
        },
    }],
    title: {
        text:'',
        show:true,
        x:'center',
        y:'55%',
        textStyle: {
          fontSize: 12,
          color:"#999",
          fontWeight:"normal"
        }
    },
    graphic:{
        type:"text",
        left:"center",
        top:"36%",
        style:{
            text:"",
            textAlign:"center",
            fill:"#333",
            fontSize:20,
            fontWeight:500
        }
    },
};
// 空数据展示
const EMPTY_OPTION = {
    series: [{
        type: 'pie',
        radius: ['75%', '100%'],
        center: ['50%', '50%'],
        data: [{name:'text',value:1}],
        hoverAnimation: false,
        labelLine: {
            show: false
        },
        label: {
            show: false,
            position: 'center'
        },
    }],
    color:['#eee'],
    title: {
        text:'暂无数据',
        show:true,
        x:'center',
        y:'center',
        textStyle: {
          fontSize: 12,
          color:"#999",
          fontWeight:"normal"
        }
    }
}

export {BASIC_OPTION,EMPTY_OPTION}